import React, { useState, useEffect } from "react";
import LoginCardBNB from "./LoginCard/LoginCardBNB";
import { ethers } from "ethers";
import { useAuth } from "../../utils/auth/AuthDetails";
import ErrorAlert from "./ErrorAlert/ErrorAlert";
import SingUpBNB from "./SingUp/SignUpBNB";
import LoginBNB from "./Login/LoginBNB";
import PlayerCreationBNB from "./PlayerCreation/PlayerCreationBNB";
import { useMutation, useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import ForgotPasswordBNB from "./ForgotPassword/ForgotPasswordBNB";
import { GENERATE_NONCE, VERIFY_WALLET, GET_PLAYER } from "./Dashboard.schema";
import axios from "axios";

function AuthBNB({
  isConnected,
  coinbase,
  handleConnect,
  isSuccess,
  onWalletLinkComplete,
  onSuccessLogin,
}) {
  const { isAuthenticated, loginError, setLoginValues, playerId, email } =
    useAuth();

  const {
    data,
    refetch: refetchPlayer,
    loading: loadingPlayer,
  } = useQuery(GET_PLAYER, {
    fetchPolicy: "network-only",
  });

  const [value, setValue] = React.useState(0);
  const [playerCreation, setplayerCreation] = useState(false);
  const [forgotPassword, setforgotPassword] = useState(false);
  const [isLogin, setisLogin] = useState(false);
  const navigate = useNavigate();
  const [linkWallet, setLinkWallet] = useState(false);
  const [showVerify, setShowVerify] = useState(false);
  const [successLink, setsuccessLink] = useState(false);

  const [generateNonce, { loading: loadingGenerateNonce, data: dataNonce }] =
    useMutation(GENERATE_NONCE);
  const [verifyWallet, { loading: loadingVerify, data: dataVerify }] =
    useMutation(VERIFY_WALLET);

  useEffect(() => {
    if (isAuthenticated && !playerId) {
      setplayerCreation(true);
      setShowVerify(true);
    }
  }, [isAuthenticated, playerId]);

  useEffect(() => {
    if (
      data &&
      data.getPlayer &&
      data.getPlayer.displayName &&
      data.getPlayer.playerId &&
      !data.getPlayer.wallet
    ) {
      setLinkWallet(true);
      setplayerCreation(true);
      setShowVerify(true);
    }
  }, [data]);

  useEffect(() => {
    if (
      isAuthenticated &&
      playerId &&
      data &&
      data.getPlayer &&
      data.getPlayer.displayName &&
      data.getPlayer.playerId &&
      data.getPlayer.wallet &&
      data.getPlayer.wallet.publicAddress
    ) {
       console.log('user is authenticated')
    }
  }, [data, playerId, isAuthenticated, isLogin]);

  useEffect(() => {
    if (dataNonce?.generateWalletNonce) {
      signWalletPublicAddress();
    }
  }, [dataNonce]);
 
  useEffect(() => {
    if (isSuccess === true && isConnected) {
      handleLinkWallet();
    }
  }, [isSuccess, isConnected]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setLoginValues(() => {
      return {
        isLoginIn: false,
        loginError: null,
      };
    });
  };

  const handleManageLoginStates = () => {
    refetchPlayer();
    if (
      isAuthenticated &&
      playerId &&
      data &&
      data.getPlayer &&
      data.getPlayer.displayName &&
      data.getPlayer.playerId &&
      data.getPlayer.wallet &&
      data.getPlayer.wallet.publicAddress
    ) {
      onSuccessLogin();
    } else if (isAuthenticated && !playerId) {
      setplayerCreation(true);
    }
  };

  const handleLinkWallet = async () => {
    if (isConnected) {
      await generateNonce({
        variables: {
          publicAddress: coinbase,
        },
      });
    } else {
      handleConnect();
    }
  };

 

  const signWalletPublicAddress = async () => {
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner(coinbase);
      const signature = await signer.signMessage(
        `Signing one-time nonce: ${dataNonce?.generateWalletNonce?.nonce}`
      );
      verifyWallet({
        variables: {
          publicAddress: coinbase,
          signature: signature,
        },
      }).then(() => {
        onWalletLinkComplete();
        // handleFirstTask(coinbase);
      });
    } catch (error) {
      console.log(error);
    }
  };

  // if (isAuthenticated && !playerId) {
  //   return <Navigate to={"/player"} />;
  // }

  // if (!playerId) {
  //   return <Navigate to={"/player"} />;
  // }

  return (
    <div className="mx-0 container-nft w-100 container-fluid d-flex align-items-start px-0 flex-column">
      <div className="d-flex flex-column  gap-2 w-100">
        <div className="nft-page-wrapper justify-content-center bg-transparent d-flex flex-column flex-lg-row gap-3 mb-3">
          <div className="col-12 col-md-12 col-lg-6 mt-0 px-0 ">
            <div className="d-flex flex-column gap-5 gap-lg-2 gap-md-2">
              <LoginCardBNB
                cardStyles={{
                  height:
                    linkWallet === true || value === 0 ? "100%" : "fit-content",
                }}
              >
                {/* {successLink === false && (
                  <div className="mt-3">
                    <ul className="timeline m-0 p-0" id="timeline">
                      <li className="col-3 li complete">
                        <div className="status">
                          <span className="text-white statusIndex">1</span>
                          <h4 className="listtext"> Register </h4>
                        </div>
                      </li>
                      <li class={`col-3 li ${showVerify && "complete"} `}>
                        <div className="status">
                          <span className="text-white statusIndex">2</span>
                          <h4 className="listtext"> Verify </h4>
                        </div>
                      </li>
                      <li class={`col-3 li ${playerCreation && "complete"} `}>
                        <div className="status">
                          <span className="text-white statusIndex">3</span>
                          <h4 className="listtext"> Profile </h4>
                        </div>
                      </li>
                      <li
                        class={`col-2 li ${linkWallet && "complete"}`}
                        style={{ width: 0 }}
                      >
                        <div className="status">
                          <span className="text-white statusIndex">4</span>
                          <h4
                            className="listtext"
                            style={{
                              width: 0,
                              whiteSpace: "nowrap",
                              left: "-17px",
                            }}
                          >
                            Link Wallet
                          </h4>
                        </div>
                      </li>
                    </ul>
                  </div>
                )} */}
                {playerCreation === true ? (
                  <PlayerCreationBNB
                    linkWallet={linkWallet}
                    onLinkWallet={handleLinkWallet}
                    successLink={successLink}
                    onShowLinkWallet={() => {
                      setLinkWallet(true);
                    }}
                  />
                ) : playerCreation === false && forgotPassword === true ? (
                  <ForgotPasswordBNB
                    onSuccess={() => {
                      setforgotPassword(false);
                      handleChange("click", 0);
                    }}
                  />
                ) : (
                  <>
                    {value === 0 &&
                      playerCreation === false &&
                      forgotPassword === false && (
                        <LoginBNB
                          onForgetPassword={() => {
                            setforgotPassword(true);
                          }}
                          onLoginTry={() => {
                            setisLogin(true);
                          }}
                          onSuccessLogin={() => {
                            onSuccessLogin();
                            handleManageLoginStates();
                            // handleFirstTask(coinbase);
                          }}
                          handleGoToSignup={() => {
                            handleChange("click", 1);
                          }}
                        />
                      )}

                    {value === 1 && playerCreation === false && (
                      <SingUpBNB
                        onUserExists={() => {
                          handleChange("click", 0);
                        }}
                        onVerifySuccess={() => {
                          setplayerCreation(true);
                        }}
                        isLogin={isLogin}
                        handleGoToLogin={() => {
                          handleChange("click", 0);
                        }}
                        onShowVerify={(value) => {
                          setShowVerify(value);
                        }}
                      />
                    )}
                  </>
                )}
              </LoginCardBNB>

              <ErrorAlert error={loginError} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AuthBNB;
